import { months } from "../constants/dictionary";

export const parseCurrency = (currency) => {
  return currency.replace(/\.00/g, "");
};

export const getCouponFromUrl = (pathname) => {
  return pathname
    .split("/")
    .find((item) => item.indexOf("coupon_") > -1)
    .replace("coupon_", "");
};

export const isValid = (type, value) => {
  return type === "billing-zip"
    ? value && value.length > 2 && value.length < 13
    : !!value.length;
};

export const getCurrentPeriodEnd = (type, currentPeriodEnd) => {
  const date = new Date(currentPeriodEnd);
  switch (type) {
    case "day":
      return date.getDate();
    case "month":
      return months[date.getMonth()];
    case "year":
      return date.getFullYear();
    default:
      return null;
  }
};
